import { createFileRoute } from "@tanstack/react-router";
import { ProposalBuilderEditor } from "@/modules/proposal-builder/components/builder/ProposalBuilderEditor";

export const Route = createFileRoute("/proposal-builder/$id")({
  component: ProposalEditRoute,
});

function ProposalEditRoute() {
  const { id } = Route.useParams();

  return <ProposalBuilderEditor proposalId={id} />;
}